<template>
  <div class="gwbtns">
    <slot name="before"></slot>
    <div
      v-for="(item, idx) in options"
      :key="`${idx}_${item[idKey] || item}`"
      :data-tst="`${tstPrefix}_${item[idKey] || item}`"
      class="gw_btn gwbtns_btn"
      :style="item.cssStyle || ''"
      :class="[
        {
          gw_btn_active: value
            ? value === (item[idKey] || item)
            : values.includes(item[idKey] || item),
        },
        {
          gw_btn_disabled: disabled ? disabled.includes(item[idKey] || item) : false,
        },
        btnClass || '',
      ]"
      @click="e => $emit('click', e, item)"
      @mouseenter="$emit('mouseenter', item)"
      @mouseleave="$emit('mouseleave', item)"
      @mousedown="$emit('mousedown', item)"
    >
      <slot
        :item="item"
        :value="value"
      >
        {{ value }}
        {{ item }}
      </slot>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
export default {
  name: 'GwBtns',
  props: {
    options: Array,
    disabled: Array,
    idKey: { default: 'id' },
    value: [String, Number, Object],
    values: { type: Array, default: () => [] },
    btnClass: String,
    tstPrefix: { default: 'gwbtn' },
  },
  emits: ['click', 'click:event', 'mouseenter', 'mouseleave', 'mousedown'],
  data() {
    return {
      mousedown: false,
    }
  },
}
</script>
<style lang="scss" scoped>
.gwbtns {
  --gwbtn-flex: unset;
  --gwbtn-flex-shrink: 0;
  --gwbtn-size: 0.875rem;
  --gwbtn-weight: 500;
  --gwbtn-padding: 0 0.25rem;
  --gwbtn-clr-back: var(--clr-black-1-3);
  --gwbtn-clr-active-white: var(--clr-black-2);
  --gwbtn-clr-hover-white: rgba(255, 255, 255, 0.25);
  --gwbtn-clr-disabled-white: rgba(255, 255, 255, 0);

  --gwbtn-clr: var(--clr-grey-2);
  --gwbtn-clr-hover: var(--clr-white-0);
  --gwbtn-clr-active: var(--clr-white-0);
  --gwbtn-padding: 0 1rem;
  --gwbtn-height: 1.5rem;
  --gwbtn-justify-content: center;

  --gwbtn-pointer-events: all;
  --gwbtn-pointer-events-disabled: unset;

  --gwbtn-clr-disabled: currentColor;

  --gwbtns-gap: 2px;
  --gwbtns-direction: row;
  --gwbtns-wrap: nowrap;
  --gwbtns-padding: 0;

  display: flex;
  align-content: flex-start;

  flex-direction: var(--gwbtns-direction);
  flex-wrap: var(--gwbtns-wrap);
  padding: var(--gwbtns-padding);
  gap: var(--gwbtns-gap);

  &_vertical_primary,
  &_vertical_grey,
  &_vertical_white {
    --gwbtns-direction: column;
    --gwbtn-justify-content: flex-start;
    --gwbtns-padding: 0.5rem 0.25rem;

    --gwbtn-padding: 0 0.5rem;
    --gwbtn-height: 1.75rem;

    --gwbtn-clr-back: transparent;
    --gwbtn-clr-hover-white: rgba(255, 255, 255, 0.125);

    --gwbtn-clr-hover: var(--clr-white-0);
    --gwbtn-clr-active: var(--clr-white-0);
  }
  &_vertical {
    &_primary {
      --gwbtn-clr: var(--clr-white-0);
      --gwbtn-clr-hover: var(--clr-primary);
      --gwbtn-clr-active: var(--clr-primary);
    }
    &_grey {
      --gwbtn-clr: var(--clr-grey-2);
    }
    &_white {
      --gwbtn-clr: var(--clr-white-0);
    }
  }

  &_horizontal_grey,
  &_horizontal_white {
    --gwbtn-padding: 0 0.5rem;

    --gwbtn-clr-back: var(--clr-black-2);

    --gwbtn-clr-hover: var(--clr-white-0);
    --gwbtn-clr-active: var(--clr-white-0);
  }
  &_horizontal {
    &_grey {
      --gwbtn-clr: var(--clr-grey-2);
      --gwbtn-clr-active-white: var(--clr-black-4);
    }
    &_white {
      --gwbtn-clr: var(--clr-white-0);
    }
  }

  &_btn {
    white-space: nowrap;

    --clr-back: var(--gwbtn-clr-back);
    font-size: var(--gwbtn-size);
    font-weight: var(--gwbtn-weight);
    padding: var(--gwbtn-padding);
    flex: var(--gwbtn-flex);
    flex-shrink: var(--gwbtn-flex-shrink);
    justify-content: var(--gwbtn-justify-content);

    --clr-active-white: var(--gwbtn-clr-active-white);
    --clr-hover-white: var(--gwbtn-clr-hover-white);
    --clr-disabled-white: var(--gwbtn-clr-disabled-white);
    --clr: var(--gwbtn-clr);
    --clr-hover: var(--gwbtn-clr-hover);
    --clr-active: var(--gwbtn-clr-active);
    --clr-disabled: var(--gwbtn-clr-disabled);
    --padding: var(--gwbtn-padding);
    --height: var(--gwbtn-height);

    --pointer-events: var(--gwbtn-pointer-events);
    --pointer-events-disabled: var(--gwbtn-pointer-events-disabled);
  }
}

.gw_btn_active.gw_btn_active_sticky {
  position: sticky;
  top: 0;
  bottom: 0;
  z-index: 9;
}
</style>
